<script lang="ts" setup>
import { AppTag } from '@libs/ui';

import type { ProductTagWithIcon } from '../../../models';

interface FerryCardTagsProps {
  warningTags: ProductTagWithIcon[];
}

const props = defineProps<FerryCardTagsProps>();
</script>

<template>
  <div v-if="props.warningTags.length" class="ferry-card-tags">
    <AppTag
      v-for="(tag, index) in props.warningTags"
      :key="index"
      type="warning"
      :icon="{ name: tag.svgIconType, size: '18' }"
      class="tag-container"
    >
      <template #title>
        <span class="tag-description">
          {{ $t(tag.description) }}
        </span>
      </template>
    </AppTag>
  </div>
</template>

<style lang="scss" scoped>
.ferry-card-tags {
  display: flex;
  justify-content: center;
}
</style>
